import _map from 'lodash/map';
import _cloneDeep from 'lodash/cloneDeep';
import { v4 as uuidv4 } from 'uuid';

import initialState from './initialState';
import actionType from './actionTypes';

const ddConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ALL_REF_DATA_DD_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                // ddConfigurations: action.payload,
                gridDDConfigurations: _cloneDeep({
                    fielddata: initialState.gridDDConfigurations.fielddata,
                    instances: _map(action.payload, (config) => ({
                        ...config,
                        id: uuidv4(),
                        filing_date: null,
                        // created_date : moment(config.created_date, "YYYY MM DD")
                    })),
                }),
                fieldNames: _map(action.payload, 'field_name'),
            };
        }
        case actionType.GET_ALL_REF_DATA_LOOKUP_DD_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                ddConfigurations: action.payload,
            };
        }
        case actionType.GET_ALL_REF_DATA_GROUP_DD_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                groupDDConfigurations: action.payload,
            };
        }
        case actionType.CLEAN_API_LOGGERS: {
            return {
                ...state,
                apiLoggers: [],
            };
        }
        case actionType.ADD_API_LOGGERS: {
            const newLoggers = _cloneDeep(state.apiLoggers);
            newLoggers.push(action.payload);
            return {
                ...state,
                apiLoggers: newLoggers,
            };
        }
        default:
            return state;
    }
};

export default ddConfigurationReducer;
